<template>
    <b-card @submit.stop.prevent="handleSubmit" no-body>
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            {{ alertText }}
        </b-alert>
        <b-tabs card>
            <b-tab
                :title="$t('prod_ingredienten', { ns: 'production' })"
                active
            >
                <b-card-text>
                    <div
                        v-for="(bakingredient, index) in platteLijst"
                        :key="`item-${componentKey}-${index}`"
                    >
                        <b-col sm="11" class="mx-0 px-0 my-1 py-0">
                            <bak-ingredient-combo
                                v-model="platteLijst[index]"
                                :editAllowed="editAllowed"
                                :baseDateTime="baseDateTime"
                                :newDateTime="newDateTime"
                                :withPrepend="true"
                                @nostock="removeButtons"
                                @change="
                                    setChangedIngredient(platteLijst[index])
                                "
                                @newDateTime="setNewDateTime"
                            />
                        </b-col>
                        <b-col sm="1" class="mx-0 px-0 my-1 py-0">
                            <b-button
                                v-if="editAllowed && stockAvailable"
                                @click="verwijderIngredient(bakingredient)"
                                class="bgc_aux_alarm"
                                ><font-awesome-icon
                                    icon="trash-alt"
                                    size="1x"
                                />
                            </b-button>
                        </b-col>
                    </div>
                </b-card-text>
            </b-tab>
            <b-tab :title="$t('com_marks', { ns: 'common' })">
                <b-card-text>
                    <b-collapse
                        id="collapseMerk"
                        v-model="gebruikKaasmerk"
                        class="mt-2"
                    >
                        <b-card>
                            <b-row v-if="showSubseries">
                                <div
                                    class="form-inline"
                                    v-for="(ucm, index) in ucmList"
                                    v-bind:key="index"
                                >
                                    <b-col sm="12" class="mx-0 px-0 my-1 py-0">
                                        <merken-combo
                                            v-bind:key="index"
                                            v-model="ucmList[index]"
                                            v-bind:editAllowed="editAllowed"
                                            v-bind:cheeseProductID="
                                                ucm.productID
                                            "
                                            @delete="verwijderMerkserie"
                                            @copy="copyMerkserie"
                                            @input="check_doublesMerkserie"
                                            @change="isChanged = true"
                                        />
                                    </b-col>
                                </div>
                            </b-row>

                            <b-row v-else>
                                <b-col sm="12">
                                    <b-row>
                                        <merken-combo
                                            v-if="currentKaasmerk != undefined"
                                            v-model="currentKaasmerk"
                                            :editAllowed="editAllowed"
                                            :cheeseProductID="localProductID"
                                            :showSubseries="showSubseries"
                                            @change="isChanged = true"
                                        />
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-alert
                                v-model="showNoStockAlert"
                                variant="danger"
                                dismissible
                            >
                                {{ alertNoStock }}
                            </b-alert>
                        </b-card>
                    </b-collapse>
                    <div
                        class="form-inline"
                        v-for="(inpekelitem, index) in inpekellijst"
                        v-bind:key="index"
                    >
                        <b-col sm="10" class="mx-0 px-0 my-1 py-0">
                            <inpekel-item-combo
                                :key="index"
                                v-model="inpekellijst[index]"
                                :editAllowed="editAllowed"
                                :cheeseProductID="objectBak.productID"
                                :baseDateTime="objectBak.boekDatum"
                                @change="set_input"
                                @input="check_doublesPekel"
                            />
                        </b-col>
                        <b-col sm="2" class="mx-0 px-0 my-1 py-0">
                            <b-button
                                v-if="editAllowed"
                                @click="copyPekel(inpekelitem)"
                                :disabled="setDisabledShape"
                                class="bgc_aux_normal"
                                ><font-awesome-icon icon="copy" size="1x" />
                            </b-button>
                            <b-button
                                v-if="editAllowed"
                                @click="verwijderPekel(inpekelitem)"
                                :disabled="setDisabledShape"
                                class="bgc_aux_alarm"
                                ><font-awesome-icon
                                    icon="trash-alt"
                                    size="1x"
                                />
                            </b-button>
                        </b-col>
                    </div>
                </b-card-text>
            </b-tab>
            <b-tab :title="$t('com_temperatuur', { ns: 'common' })">
                <b-input-group
                    v-if="hastempTherm"
                    class="mx-0 px-0 my-1 py-0 form-inline"
                    :prepend="
                        $t('prod_xtemperatuur', {
                            ns: 'production',
                            val: $t('prod_therm', {
                                ns: 'production'
                            })
                        })
                    "
                >
                    <temperature-input
                        v-model.number="objectBak.thermTemp"
                        @input="isChanged = true"
                        :editAllowed="editAllowed"
                        :showFahrenheit="showFahrenheit"
                        :placeholderC="$t('com_temperatuur', { ns: 'common' })"
                    />
                </b-input-group>
                <b-input-group
                    v-if="hastempPasteur"
                    class="mx-0 px-0 my-1 py-0 form-inline"
                    :prepend="
                        $t('prod_xtemperatuur', {
                            ns: 'production',
                            val: $t('prod_past', {
                                ns: 'production'
                            })
                        })
                    "
                >
                    <temperature-input
                        v-model.number="objectBak.pastTemp"
                        @input="isChanged = true"
                        :editAllowed="editAllowed"
                        :showFahrenheit="showFahrenheit"
                        :placeholderC="$t('com_temperatuur', { ns: 'common' })"
                    />
                </b-input-group>
                <b-input-group
                    v-if="isCreated"
                    class="mx-0 px-0 my-1 py-0 form-inline"
                    :prepend="
                        $t('prod_xtemperatuur', {
                            ns: 'production',
                            val: $t('prod_strem', {
                                ns: 'production'
                            })
                        })
                    "
                >
                    <temperature-input
                        v-model.number="objectBak.stremTemp"
                        @input="isChanged = true"
                        :editAllowed="editAllowed"
                        :showFahrenheit="showFahrenheit"
                        :placeholderC="$t('com_temperatuur', { ns: 'common' })"
                    />
                </b-input-group>
                <b-input-group
                    v-if="isCreated"
                    class="mx-0 px-0 my-1 py-0 form-inline"
                    :prepend="
                        $t('prod_xtemperatuur', {
                            ns: 'production',
                            val: $t('prod_nawarm', {
                                ns: 'production'
                            })
                        })
                    "
                >
                    <temperature-input
                        v-model.number="objectBak.nawarmTemp"
                        @input="isChanged = true"
                        :editAllowed="editAllowed"
                        :showFahrenheit="showFahrenheit"
                        :placeholderC="$t('com_temperatuur', { ns: 'common' })"
                    />
                </b-input-group>
            </b-tab>
            <activity-log :lijst="activityList" />
            <steps-log :lijst="stepsList" />
            <b-tab :title="$t('com_recipe', { ns: 'common' })">
                <recipe-card
                    v-if="isCreated"
                    v-model="recept"
                    :editAllowed="false"
                    :closedRecipesList="null"
                />
            </b-tab>
        </b-tabs>
        <b-card :header="$t('com_opmerking', { ns: 'common' })">
            <b-col sm="9" class="mx-0 px-0 my-0 py-0">
                <b-col sm="3" class="mx-0 px-0 my-0 py-0">
                    <label
                        >{{ $t('prod_verantw', { ns: 'production' }) }}:
                    </label>
                </b-col>
                <b-col sm="9" class="mx-0 px-0 my-0 py-0">
                    <b-form-input
                        id="dropdown-form-responsibel"
                        :placeholder="$t('prod_verantw', { ns: 'production' })"
                        v-model="selectedPerson"
                        :disabled="!editAllowed"
                        size="sm"
                    ></b-form-input>
                </b-col>
            </b-col>
            <b-col sm="3" class="mx-0 px-0 my-0 py-0"> </b-col>
            <b-form-textarea
                id="bakopmerking"
                v-model="bakOpmerking"
                :placeholder="$t('com_opmerking', { ns: 'common' })"
                rows="3"
                max-rows="6"
                :disabled="!editAllowed"
            ></b-form-textarea>

            <b-button
                @click="saveValues()"
                class="bgc_aux_warning float-right"
                :disabled="!isChanged"
                >{{ $t('com_opslaan', { ns: 'common' }) }}
            </b-button>
        </b-card>
    </b-card>
</template>

<script>
import { Bak } from '../../models/BakInfo';
import {
    BakIngredientCombo,
    MerkenCombo,
    InpekelItemCombo,
    ActivityLog,
    StepsLog,
    TemperatureInput
} from '../components';
import { RecipeCard } from '../recipe';
import Helper from '../../models/Helper';
import { INGRCAT_ENUM } from '../../models/IngredientCategorie';
import { loadItem, loadList } from '../../models/DataHelper';
import { Feature } from '@/models/Features';
import { loadComplete } from './productionservice';
export default {
    name: 'ProductionCard',
    data: function () {
        return {
            hastempPasteur: false,
            hastempTherm: false,
            isCreated: false,
            lctypeCheeses: window.constants.LCCHEESE,
            lctypeCheesesWithoutRecipe: window.constants.LCCHEESEWITHOUTRECIPE,
            lctypeIngredient: window.constants.LCINGREDIENT,
            batchIDtoSelect: null,
            newDateTime: null,
            nostock: false,
            bakOpmerking: '',
            selectedPerson: '',
            showDismissibleAlert: false,
            alertText: '',
            aangeraakt: 0,
            preselectedStarterProduct: -1,
            timeIsSet: false,
            objectBak: null,
            platteLijst: [],
            isChanged: false,
            gebruikKaasmerk: true,
            showNoStockAlert: false,
            showSubseries: false,
            componentKey: 1,
            prevMelk: 0,
            markstockList: [],
            recept: {},
            currentKaasmerk: null,
            alertNoStock: this.$t('prod_nostock', {
                ns: 'production',
                val: this.$t('com_marks', {
                    ns: 'common'
                })
            })
        };
    },
    model: {
        prop: 'theBatch',
        event: 'changedRecipe'
    },
    props: {
        theBatch: {
            type: Bak,
            required: true
        },
        activityList: {
            type: Array
        },
        stepsList: {
            type: Array
        },
        editAllowed: {
            type: Boolean,
            default: false
        }
    },
    components: {
        BakIngredientCombo,
        MerkenCombo,
        ActivityLog,
        StepsLog,
        InpekelItemCombo,
        TemperatureInput,
        RecipeCard
    },
    watch: {},
    computed: {
        ucmList() {
            // eslint-disable-next-line no-unused-vars
            const tel = this.aangeraakt;
            if (this.objectBak == null || this.objectBak.bakKaasMerk == null)
                return [];
            return this.objectBak.bakKaasMerk.subSeries.filter(
                (x) =>
                    x.isDeleted == false &&
                    (x.nouse == undefined || x.nouse == false)
            );
        },
        flexList() {
            return this.markstockList.map((x) => ({
                value: x.id,
                text:
                    x.letters +
                    ' (' +
                    x.startnummer +
                    ' - ' +
                    x.eindnummer +
                    ' )',
                stockItemId: x.id,
                letter: x.letters,
                start: x.startnummer,
                eind: x.eindnummer
            }));
        },
        inpekellijst() {
            if (this.objectBak == null || this.objectBak.inpekelAmounts == null)
                return [];
            return this.objectBak.inpekelAmounts.filter(
                (x) =>
                    x.isDeleted == false &&
                    (x.nouse == undefined || x.nouse == false)
            );
        },
        setDisabledShape() {
            const disableMultipleProductShapes = this.checkFeature(
                'conf_disableMultipleProductShapes'
            );
            return disableMultipleProductShapes;
        },
        stockAvailable() {
            return !this.nostock;
        },
        baseUnit() {
            return this.theBatch.recipeUnitID;
        },
        baseDateTime() {
            return this.theBatch.productieDatum;
        },
        showFahrenheit() {
            const useF = this.checkFeature('conf_useFahrenheitinProduction');
            return useF;
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        change(visible) {
            this.$emit('change', visible);
        },
        removeButtons(value) {
            this.nostock = value;
        },
        maakLijst(obj) {
            // zoek het subtype op van het voorgeselecteerde
            const running = this.objectBak.runstatus > 0;
            let uniekIDteller = -1;
            let preselectedIngredient = null;
            const handleStarterGroup = this.checkFeature(
                'conf_handleStarterGroup'
            );
            if (this.preselectedStarterProduct > -1) {
                const zuursellijst =
                    this.$store.getters['product/getZuurselSubtypes'];
                preselectedIngredient = zuursellijst.find(
                    (x) => x.productID == this.preselectedStarterProduct
                );
            }
            const lijst = [];
            for (let i = 0; i < obj.length; i++) {
                const bilijst = obj[i];
                for (let j = 0; j < bilijst.bakIngredienten.length; j++) {
                    const bi = bilijst.bakIngredienten[j];
                    bi.checkAmount = bilijst.checkAmount;
                    bi.ingredientCat = bilijst.ingredientCategorieNaam;
                    bi.ingredientCatId = bilijst.ingredientCategorieID;
                    bi.special = bilijst.special;
                    bi.bakID = bilijst.bakId;
                    if (bi.nouse == undefined || bi.nouse == false) {
                        if (bi.ingredientCatId == INGRCAT_ENUM.Zuursel) {
                            if (this.preselectedStarterProduct > -1) {
                                const groep = bi.special;
                                const haalweg = handleStarterGroup
                                    ? preselectedIngredient?.zuurselSubType !=
                                      groep
                                    : this.preselectedStarterProduct !=
                                          bi.productID &&
                                      preselectedIngredient?.zuurselSubType ==
                                          groep;
                                if (haalweg) {
                                    // als er een voorgeselecteerde starter is, maar deze komt niet overeen met het productID van de bakIngredient, sla deze dan over
                                    continue;
                                }
                            }
                            if (running && bi.isNew) {
                                // als de bak al in bewerking is, en dit ingredient nieuw is (dus toegevoegd na starten productie), haal deze dan weg
                                continue;
                            }
                        }
                        bi.deleteID = uniekIDteller--;
                        lijst.push(bi);
                    }
                }
            }
            const sortedLijst = [...lijst].sort((a, b) => {
                if (a.ingredientCatId !== b.ingredientCatId) {
                    return a.ingredientCatId - b.ingredientCatId;
                }
                const naamA = a.naam ?? '';
                const naamB = b.naam ?? '';
                return naamA.localeCompare(naamB);
            });
            return sortedLijst;
        },
        calcTotMelk() {
            const tempArr2 = this.platteLijst.map((x) =>
                x.checkAmount == false ? (x.hoeveelheid ?? 0) * x.factor : 0
            );
            const result = _.sum(tempArr2);
            return result;
        },
        adjustListAmounts(factor) {
            for (let i = 0; i < this.platteLijst.length; i++) {
                const ing = this.platteLijst[i];
                if (ing.nouse == false && ing.isNew && ing.checkAmount) {
                    const hoeveelheid = (ing.hoeveelheid * factor).toFixed(3);
                    this.platteLijst[i].hoeveelheid = hoeveelheid;
                    this.componentKey += 1;
                }
            }
        },
        setChangedIngredient(ingredient) {
            if (ingredient.checkAmount == false) {
                // rare manier om melk te detecteren maar zo werkte het al
                // herbereken hoeveelheden
                const newMelk = this.calcTotMelk();
                this.prevMelk = this.prevMelk == 0 ? newMelk : this.prevMelk;
                const milkCalcFactor = newMelk / this.prevMelk;
                this.objectBak.prodcalcFactor = milkCalcFactor;
                this.prevMelk = newMelk;
                if (milkCalcFactor != 1) this.adjustListAmounts(milkCalcFactor);
            }
            this.setChanged();
        },
        async verwijderIngredient(bakingredient) {
            const item = this.platteLijst.find((x) => {
                return (
                    x.deleteID === bakingredient.deleteID &&
                    (x.nouse == undefined || x.nouse == false)
                );
            });
            if (item) {
                if (!item.isNew) {
                    // verwijder direct uit database, niet wachten tot save
                    const doClose = await this.$root.showConfirmationBox(
                        this.$t('com_delete', {
                            ns: 'common',
                            val: this.$t('prod_ingredient', {
                                ns: 'production'
                            })
                        }) + bakingredient.naam
                    );
                    if (doClose) {
                        item.isDeleted = true;
                        await this.deleteBakIngredientItem(item);
                    }
                }
                const index = this.platteLijst.findIndex((x) => {
                    return (
                        x.deleteID === bakingredient.deleteID &&
                        (x.nouse == undefined || x.nouse == false)
                    );
                });
                if (index > -1) {
                    this.platteLijst.splice(index, 1);
                    this.aangeraakt += 1;
                    this.showDismissibleAlert = false;
                }
                //this.check_doubles(); // niet nodig, kunnen hier niet toevoegen
                this.setChanged();
            }
        },
        setNewDateTime(value) {
            if (!this.timeIsSet) {
                this.newDateTime = value;
                this.timeIsSet = true;
            }
        },
        async loadKaasMerkVoorstel(km) {
            if (km.merkProductID != undefined) {
                const marktype = await loadItem(
                    'production/loadMarkType',
                    { productID: km.merkProductID },
                    this.$t
                );
                let merkFilled = false;
                if (marktype.data.lastUsedLetter != undefined) {
                    const objTest = this.flexList.find(
                        (x) =>
                            x.letter == marktype.data.lastUsedLetter &&
                            x.start <= marktype.data.lastUsedNumber &&
                            x.eind > marktype.data.lastUsedNumber
                    );
                    if (objTest) {
                        km.startLetter = marktype.data.lastUsedLetter;
                        km.eindLetter = marktype.data.lastUsedLetter;
                        km.startNummer = marktype.data.lastUsedNumber + 1;
                        merkFilled = true;
                    }
                }
                if (!merkFilled) {
                    // nieuw merkenserie
                    if (this.flexList.length > 0) {
                        km.startLetter = this.flexList[0].letter;
                        km.eindLetter = this.flexList[0].letter;
                        km.startNummer = this.flexList[0].start;
                    }
                }
                km.eindNummer = km.startNummer + km.kazen - 1;
                const obj = this.flexList.find(
                    (x) =>
                        x.letter == km.startLetter &&
                        x.start <= km.startNummer &&
                        x.eind > km.startNummer
                );
                if (obj) {
                    // we hebben een startserie
                    this.currentKaasmerk.beginStockItemID = obj.stockItemId;
                    this.currentKaasmerk.eindStockItemID = obj.stockItemId;
                    // als ze starten met een serie dan is lastUsedNumber hier null
                    if (km.startNummer == undefined && obj != undefined) {
                        // waarschijnlijk start nieuwe serie dus is startnummer nummer 1 van die serie
                        km.startNummer = obj.start;
                    }
                    km.eindNummer = km.startNummer + km.kazen - 1;
                } else {
                    const obj1 = this.flexList.find(
                        (x) =>
                            x.letters == km.eindLetter &&
                            x.start < km.eindNummer &&
                            x.eind >= km.eindNummer
                    );
                    const stockID1 = obj1 ? obj1.stockItemId : null;
                    this.currentKaasmerk.eindStockItemID = stockID1;
                }
                // nieuw: vul ook het voorstel voor de subseries, zijn gesorteerd op belangrijkheid (aantal)
                let start = km.startNummer;
                const lijst = km.subSeries.filter(
                    (x) =>
                        x.isDeleted == false &&
                        (x.nouse == undefined || x.nouse == false)
                );
                for (let i = 0; i < lijst.length; i++) {
                    lijst[i].beginStockItemID =
                        this.currentKaasmerk.beginStockItemID;
                    lijst[i].eindStockItemID =
                        this.currentKaasmerk.eindStockItemID; // klopt meestal
                    lijst[i].startLetter = km.startLetter;
                    lijst[i].eindLetter = km.startLetter;
                    lijst[i].startNummer = start;
                    lijst[i].eindNummer =
                        lijst[i].startNummer + lijst[i].kazen - 1;
                    start = lijst[i].startNummer + lijst[i].kazen;
                }
                this.aangeraakt += 1;
            } else {
                if (this.flexList.length > 0) {
                    this.currentKaasmerk.startStockItemID =
                        this.flexList[0].stockItemId;
                    this.currentKaasmerk.eindStockItemID =
                        this.flexList[0].stockItemId;
                    km.startNummer = this.flexList[0].start;
                    km.eindNummer = km.startNummer + km.kazen - 1;
                }
            }
            this.currentKaasmerk = km;
            if (this.eindNummerBasis == undefined)
                this.eindNummerBasis = this.currentKaasmerk.eindNummer;
            this.isChanged = true;
            return km;
        },
        async verwijderMerkserie(subserie) {
            const item = this.objectBak.bakKaasMerk.subSeries.find((x) => {
                return (
                    x.bakId === subserie.bakId &&
                    x.vormID === subserie.vormID &&
                    x.productID === subserie.productID &&
                    x.nouse == undefined
                );
            });
            if (item) {
                if (item.isNew) {
                    const index =
                        this.objectBak.bakKaasMerk.subSeries.findIndex((x) => {
                            return (
                                x.bakId === subserie.bakId &&
                                x.vormID === subserie.vormID &&
                                x.productID === subserie.productID &&
                                x.nouse == undefined
                            );
                        });
                    if (index > -1) {
                        this.objectBak.bakKaasMerk.subSeries.splice(index, 1);
                        this.aangeraakt += 1;
                        this.showDismissibleAlert = false;
                    }
                } else {
                    const doClose = await this.$root.showConfirmationBox(
                        this.$t('com_delete', {
                            ns: 'common',
                            val: this.$t('prod_subserie', {
                                ns: 'production'
                            })
                        }) +
                            subserie.bakId +
                            ':' +
                            subserie.vormID
                    );
                    if (doClose) {
                        item.isDeleted = true;
                        this.aangeraakt += 1;
                        this.setChanged();
                    }
                }
                this.check_doublesMerkserie();
            }
        },
        copyMerkserie(merkitem) {
            const nieuw = new CheeseMarks({
                batchID: merkitem.bakId,
                productID: merkitem.productID,
                merkProductID: merkitem.merkProductID,
                markTypeID: merkitem.markTypeID
            });
            nieuw.kazen = 0;
            nieuw.vormID = merkitem.vormID;
            nieuw.beginStockItemID = merkitem.beginStockItemID;
            nieuw.eindStockItemID = merkitem.eindStockItemID;
            nieuw.startLetter = merkitem.startLetter;
            nieuw.eindLetter = merkitem.eindLetter;
            this.objectBak.bakKaasMerk.subSeries.push(nieuw);
            this.aangeraakt += 1;
            this.setChanged();
        },
        check_doublesMerkserie() {
            this.$nextTick(() => {
                const x = _(this.objectBak.bakKaasMerk.subSeries.slice(0))
                    .groupBy((x) => `"${x.vormID}+${x.productID}"`)
                    .map((value, key) => ({
                        categorie: key,
                        subserie: value
                    }))
                    .value();
                const y = x.filter((o) => o.subserie.length > 1);
                this.validMarks = !(y.length > 0);
                if (y.length > 0) {
                    this.showAlert(this.messageUniek);
                } else {
                    this.check_maxStockItemNumber();
                }
            });
        },
        check_maxStockItemNumber() {
            // maximaal 2 merkvoorraaditems in het spel zijn. 3 is errorer mogen
            const a = this.objectBak.bakKaasMerk.subSeries.slice(0);
            const arrStockIds = a.map((x) => x.beginStockItemID);
            const b = a.map((x) => x.eindStockItemID);
            arrStockIds.push(...b);
            arrStockIds.push(this.objectBak.bakKaasMerk.beginStockItemID);
            arrStockIds.push(this.objectBak.bakKaasMerk.eindStockItemID);
            const unique = arrStockIds.filter(
                (value, index, array) => array.indexOf(value) === index
            );
            if (unique.length > 2) {
                this.showAlert(this.messageMaxSeries);
                return false;
            }
            return true;
        },
        check_doublesPekel() {
            const x = _(this.inpekellijst.slice(0))
                .groupBy((x) => `"${x.vormID}+${x.productID}"`)
                .map((value, key) => ({
                    categorie: key,
                    inpekel: value
                }))
                .value();
            const y = x.filter((o) => o.inpekel.length > 1);
            this.gewichtValid = !(y.length > 0);
            if (y.length > 0) {
                this.showAlert(
                    this.$t('prod_warnuniekinlijst2', { ns: 'production' })
                );
            }
        },
        async verwijderPekel(inpekelitem) {
            const item = this.objectBak.inpekelAmounts.find((x) => {
                return (
                    x.bakId === inpekelitem.bakId &&
                    x.vormID === inpekelitem.vormID &&
                    x.nouse == undefined
                );
            });
            if (item) {
                if (item.isNew) {
                    const index = this.objectBak.inpekelAmounts.findIndex(
                        (x) => {
                            return (
                                x.bakId === inpekelitem.bakId &&
                                x.vormID === inpekelitem.vormID &&
                                x.nouse == undefined
                            );
                        }
                    );
                    if (index > -1) {
                        this.objectBak.inpekelAmounts.splice(index, 1);
                        this.aangeraakt += 1;
                        this.showDismissibleAlert = false;
                    }
                } else {
                    const doClose = await this.$root.showConfirmationBox(
                        this.$t('com_delete', {
                            ns: 'common',
                            val: this.$t('prod_inpekel', { ns: 'production' })
                        }) +
                            inpekelitem.bakId +
                            ':' +
                            inpekelitem.vormID
                    );
                    if (doClose) {
                        item.isDeleted = true;
                        this.aangeraakt += 1;
                        this.set_input();
                    }
                }
                this.check_doublesPekel();
            }
        },
        copyPekel(inpekelitem) {
            const nieuw = new InpekelItem({
                bakId: inpekelitem.bakId,
                productID: inpekelitem.productID
            });
            nieuw.inpekelTijd = DateHelper.convertedToTime();
            this.objectBak.inpekelAmounts.push(nieuw);
            this.aangeraakt += 1;
            this.set_input();
        },
        checkMerkenOpgelegd() {
            if (this.objectBak.bakStats.length > 0) return;
            if (this.objectBak.merkenOpgelegd == undefined) return;
            if (!this.objectBak.merkenOpgelegd) {
                this.showAlert(
                    this.$t('prod_geenmerken', { ns: 'production' })
                );
            }
        },
        checkMerkenEqualsKaas() {
            if (this.objectBak.bakStats.length > 0) return false;
            if (this.objectBak.merkenOpgelegd == undefined) return;
            this.showWarningAlert = false;
            const tot = this.inpekellijst.reduce(
                (accumulator, currentValue) =>
                    accumulator + currentValue.amount,
                0
            );
            const result = tot - this.objectBak.opgelegdeMerken;
            if (result != 0) {
                const message = Helper.stringformat(
                    this.$t('prod_merkentovkaas', { ns: 'production' }),
                    this.objectBak.opgelegdeMerken,
                    tot
                );
                this.showReminder(message);
            }
            return result == 0;
        },
        set_input() {
            this.setChanged();
            this.checkMerkenEqualsKaas();
            this.checkMerkenOpgelegd();
        },
        setChanged() {
            if (this.isCreated) {
                this.isChanged = true;
            }
        },
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        async refreshBakIngredientItem(item) {
            const refreshedItem = await this.getBakIngredientItem(item);
            if (item.gewijzigd < refreshedItem.gewijzigd) {
                this.showAlert(
                    Helper.stringformat(
                        this.$t(prod_ingrnosave, { ns: 'production' }),
                        this.$t(prod_ingredient, {
                            ns: 'production'
                        }).toLowerCase(),
                        item.naam
                    )
                );
                return;
            }
            refreshedItem.klaarzetten = item.klaarzetten;
            refreshedItem.hoeveelheid = item.hoeveelheid;
            refreshedItem.eenheidID = item.eenheidID;
            refreshedItem.toegevoegdTijd = item.toegevoegdTijd;
            refreshedItem.alternatieven = item.alternatieven;
            if (item.partijID) refreshedItem.partijID = item.partijID;
            return refreshedItem.SetForAdd();
        },
        async getBakIngredientItem(item) {
            return await loadItem(
                'production/loadBatchIngredient',
                {
                    batchingredientid: item.id
                },
                this.$t
            );
        },
        async deleteBakIngredientItem(item) {
            const refreshedItem = await this.getBakIngredientItem(item);
            const RemoveBatchIngredientModel = refreshedItem.SetForDelete();
            await loadItem(
                'production/deleteBatchIngredient',
                RemoveBatchIngredientModel,
                this.$t
            );
        },
        async handleBakIngredientenLijst(lijst) {
            if (lijst == undefined) return [];
            const filtered = lijst.filter((x) => !x.nouse);
            const toDelete = filtered.filter((x) => x.isDeleted); // als het goed is altijd leeg
            const remainder = filtered.filter((x) => !x.isDeleted);
            // handel delete
            if (toDelete.length > 0) {
                console.log('deleting items not OK');
            }
            if (remainder.length < 1) return remainder;
            // handel rest, partijen zonder partijid doen we niet
            const remainderClear = remainder.filter((x) => {
                // als nieuw dan moet partij id
                const nieuwCompleet = x.isNew
                    ? x.isNew && x.partijID != undefined
                    : true;
                if (x.isChanged && nieuwCompleet) return x;
            });
            //onst result = remainder.map((x) => x.SetForAdd());
            const result = remainderClear.map(async (x) => {
                const res = x.isNew
                    ? await Promise.resolve(x.SetForAdd())
                    : await this.refreshBakIngredientItem(x);
                return res;
            });
            return Promise.all(result);
        },
        checkFormValidity() {
            const invalidBasis = this.objectBak.CheckValidity(
                this.$t,
                this.platteLijst
            );
            if (invalidBasis) {
                this.showAlert(invalidBasis);
                return false;
            }
            return true;
        },
        async saveValues() {
            if (!this.checkFormValidity()) return;
            // zet melk op eind
            const tempLijst = [...this.platteLijst];
            const melkarr = [];
            for (let i = 0; i < tempLijst.length; i++) {
                const ing = tempLijst[i];
                if (ing.checkAmount == false) {
                    melkarr.push(i);
                }
            }
            for (let i = melkarr.length - 1; i >= 0; i--) {
                const melk = tempLijst[melkarr[i]];
                tempLijst.splice(melkarr[i], 1);
                tempLijst.push(melk);
            }
            const saveLijstIngredienten = await this.handleBakIngredientenLijst(
                tempLijst
            );
            //let res = true;
            let res = await loadItem(
                'production/addBatchingredients',
                saveLijstIngredienten,
                this.$t
            );
            const UpdateBatchModel = this.objectBak.SetForUpdate();
            UpdateBatchModel.Remark = this.bakOpmerking;
            UpdateBatchModel.ResponsiblePerson = this.selectedPerson;
            if (UpdateBatchModel) {
                res += await loadItem(
                    'production/updateBatch',
                    UpdateBatchModel,
                    this.$t
                );
            }
            const batchCheeseMarksModel = this.objectBak.SetForUpdateCheeseMark(
                this.showSubseries
            );
            if (batchCheeseMarksModel != undefined) {
                res += await loadItem(
                    'production/updateBatchMarks',
                    batchCheeseMarksModel,
                    this.$t
                );
            }
            const inbrineModel = this.objectBak.SetForUpdateInpekel();
            res += await loadItem(
                'production/updateBatchInBrine',
                inbrineModel,
                this.$t
            );
            this.$emit('closeMe', res);
        }
    },
    mounted() {},
    async created() {
        const prod = this.$store.getters['production/getSelectedProdrun'];
        this.preselectedStarterProduct =
            prod.zuurselTypeID ?? this.theBatch.zuurselTypeID;
        this.bakOpmerking = this.theBatch.opmerking;
        this.selectedPerson = this.theBatch.verantwoordelijke;
        const o = { batchID: this.theBatch.id };
        await loadItem('production/loadBatchInbrineAmounts', o, this.$t);
        await loadItem('production/loadBatchDefaults', o, this.$t);
        await loadItem('production/loadMilkusagefactor', o, this.$t);
        await loadItem('production/loadBatchIngredients', o, this.$t);
        await loadItem(
            'production/loadBatchAlternativeCheeseTypes',
            o,
            this.$t
        );
        const recept = await loadItem(
            'recipe/loadRecipeComplete',
            { recipeid: this.theBatch.receptID },
            this.$t
        );
        this.recept = recept;

        this.theBatch.recIngredienten = recept.recIngredienten ?? [];
        this.theBatch.bakIngredienten = await loadList(
            'production/getBatchIngredientenLijst',
            'production/loadBatchIngredients',
            o,
            true,
            this.$t
        );

        // haal de merkenseries op die op voorraad zijn voor deze kaassoort
        const locLijst = await loadList(
            'components/getCheesesComboLijst',
            'components/loadCheesesComboLijst',
            null,
            false,
            this.$t
        );
        this.objectBak = await loadComplete(this.theBatch, this.$t);
        if (this.objectBak.bakKaasMerk.merkProductID != undefined) {
            this.markstockList = await loadList(
                'stock/getMarkStockItemLijst',
                'stock/loadMarkStockByProduct',
                { productid: this.objectBak.bakKaasMerk.merkProductID },
                true,
                this.$t
            );
            this.showNoStockAlert = this.markstockList.length < 1;
        }

        if (recept.recNorm.pasteurisatieTemp != undefined) {
            this.hastempPasteur = recept.recNorm.pasteurisatieTemp != undefined;
            this.objectBak.pastTemp =
                this.objectBak.pastTemp ?? recept.recNorm.pasteurisatieTemp;
        }
        if (recept.recNorm.thermisatieTemp != undefined) {
            this.hastempTherm = recept.recNorm.thermisatieTemp != undefined;
            this.objectBak.thermTemp =
                this.objectBak.thermTemp ?? recept.recNorm.thermisatieTemp;
        }
        this.objectBak.stremTemp = this.objectBak.stremTemp ?? recept.stremTemp;
        this.objectBak.nawarmTemp =
            this.objectBak.nawarmTemp ?? recept.nawarmTemp;

        this.platteLijst = this.maakLijst(this.objectBak.bakIngredienten);
        this.prevMelk = this.calcTotMelk();
        this.gebruikKaasmerk = this.markstockList.length > 0;
        this.showSubseries = this.checkFeature('conf_useCheeseMarkSubseries');
        this.currentKaasmerk = this.objectBak.bakKaasMerk;
        if (this.objectBak.bakKaasMerk.suggestion) {
            this.objectBak.bakKaasMerk = await this.loadKaasMerkVoorstel(
                this.objectBak.bakKaasMerk
            );
            this.currentKaasmerk = this.objectBak.bakKaasMerk;
        } else {
            if (!this.showSubseries) {
                this.showSubseries =
                    this.objectBak.bakKaasMerk.beginStockItemID != undefined
                        ? this.objectBak.bakKaasMerk.subSeries.length > 0
                        : false;
            }
        }
        this.isCreated = true;
    }
};
</script>

<style scoped></style>
